import React, { useEffect, useState } from "react";
// import Meta from "../../components/Meta";
import { ConnectEmbed } from "thirdweb/react";
import { useTheme } from 'next-themes';
import { useRouter } from "next/router";
import { getUserEmail } from "thirdweb/wallets/in-app";
import { inAppWallet } from "thirdweb/wallets";
import { client } from "../../lib/thirdweb";

import { withHeaderProps } from "../../lib/withHeaderProps";

import Meta from "../../components/Meta";
import  convertB2ToS3Url  from "../../utils/convertB2toS3Url";
const Login = ({headerData}) => {

    const { theme } = useTheme();
    const router = useRouter();
    const [loggedIn, setLoggedIn] = useState(false);
    // const { redirectAfterAuth } = useAuthRedirect();
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    
    // Update to use the new JSON structure
    const brandConfig = headerData?.brand?.config || {};
    const themeConfig = headerData?.brand?.theme || {};
    const signinConfig = brandConfig.signin || {};
   const signinSeo = headerData?.brand?.config?.seoSettings?.login || headerData?.brand?.config?.seoSettings?.default;
    const customTheme = {
        dark: {
            colors: {
                modalBg: themeConfig.background || "#000000",
                borderColor: themeConfig.icons || "#ffffff",
                primaryButtonText: "#ffffff",
                primaryButtonBg: themeConfig.buttons || "#000000", 
                primaryText: themeConfig.text || "#ffffff",
                secondaryText: themeConfig.icons || "#ffffff",
            }
        },
        light: {
            colors: {
                modalBg: "#ffffff",
                borderColor: themeConfig.icons || "#000000",
                primaryButtonText: "#ffffff",
                primaryButtonBg: themeConfig.buttons || "#000000",
                primaryText: themeConfig.text || "#000000",
                secondaryText: themeConfig.icons || "#000000",
            }
        }
    };

    // Set the theme based on signin config preference if available
    const preferDarkMode = signinConfig.darkMode !== undefined ? signinConfig.darkMode : (theme === 'dark');
    const currentTheme = preferDarkMode ? customTheme.dark : customTheme.light;

    const wallets = [
        inAppWallet({
            auth: {
                options: [
                    "email",
                    "google",
                    "apple",
                    "facebook"
                ]
            }
        })
    ];

    return (
        <>
        <Meta 
            title={signinSeo?.title} 
            description={signinSeo?.description} 
        />
            <div 
                className=" px-8 md:px-4  min-h-[calc(100vh-265px)] flex flex-col justify-center items-center" 
                // style={{ backgroundColor: currentTheme.colors.modalBg }}
            >
                {/* <Meta 
                    title='Secure Sign In | NetZylo' 
                    description='Log in securely to access your account. Enjoy a seamless and safe user experience with our sign-in process.' 
                /> */}
                <div 
                    className=" mx-auto max-w-[500px]" 
                    style={{ 
                        // backgroundColor: currentTheme.colors.modalBg,
                        borderColor: currentTheme.colors.borderColor 
                    }}
                >
                    <div className="relative w-full h-full thirdweb-connect-embed">
          
                        
                        <ConnectEmbed
                        
                        client={client}
                        wallets={wallets}
                        showThirdwebBranding={false}
                        auth={{
                            getLoginPayload: async (params) => {
                                console.log(params)
                                if (!params?.address) {
                                    console.error("Cannot generate payload: No wallet address provided");
                                    throw new Error("Wallet connection required");
                                }
                                
                                const response = await fetch('/api/auth/generate-payload', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ address: params.address })
                                });
                                return await response.json();
                            },
                            doLogin: async (params) => {
                                console.log(params)
                                try {
                                    if (!params?.payload || !params?.signature) {
                                        console.error("Cannot login: Missing required authentication data");
                                        throw new Error("Authentication data incomplete");
                                    }
                                    
                                    const userEmail = await getUserEmail({ client });
                                    const response = await fetch('/api/auth/login', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ payload: params, email: userEmail })
                                    });
                                    
                                    if (!response.ok) {
                                        throw new Error('Login request failed');
                                    }
                                    
                                    // Ensure we have a valid session before redirecting
                                    const authCheckResponse = await fetch('/api/auth/verify');
                                    const authData = await authCheckResponse.json();
                                    
                                    if (authData.valid) {
                                        // Small delay to ensure everything is processed
                                        await new Promise(resolve => setTimeout(resolve, 300));
                                        
                                        // Clear the auth_in_progress cookie by calling a new API endpoint
                                        await fetch('/api/auth/clear-progress', { method: 'POST' });
                                        router.push("/wallet");
                                        // await redirectAfterAuth();
                                    } else {
                                        throw new Error('Session validation failed');
                                    }
                                } catch (error) {
                                    console.error('Login failed:', error);
                                    
                                    // Clear the auth_in_progress cookie on error
                                    await fetch('/api/auth/clear-progress', { method: 'POST' }).catch(e => console.error(e));
                                    
                                    // Show error to user or handle appropriately
                                }
                            },
                            isLoggedIn: async () => {
                                const response = await fetch('/api/auth/verify');
                                const data = await response.json();
                                return data.valid;
                            },
                            doLogout: async () => {
                                await handleDisconnect();
                                await fetch('/api/auth/logout', { method: 'GET' });
                                // await disconnectWallet();
                                ;
                            },
                        }}
                            className="w-full !border-none !min-w-full"
                            // style={{ backgroundColor: currentTheme.colors.modalBg }}
                            theme={
                              {
                                // colors: {
                                //     modalBg: themeConfig.background || "#000000",
                                //     borderColor: themeConfig.icons || "#ffffff",
                                //     primaryButtonText: "#ffffff",
                                //     primaryButtonBg: themeConfig.buttons || "#000000",
                                //     primaryText: themeConfig.text || "#ffffff",
                                //     secondaryText: themeConfig.icons || "#ffffff",
                                // }
                            }
                            // ,
                            //   preferDarkMode ? 
                            //     darkTheme({
                            //         colors: {
                            //             modalBg: themeConfig.background || "#000000",
                            //             borderColor: themeConfig.icons || "#ffffff",
                            //             primaryButtonText: "#ffffff",
                            //             primaryButtonBg: themeConfig.buttons || "#000000",
                            //             primaryText: themeConfig.text || "#ffffff",
                            //             secondaryText: themeConfig.icons || "#ffffff",
                            //         }
                            //     }) : 
                            //     lightTheme({
                            //         colors: {
                            //             modalBg: "#ffffff",
                            //             borderColor: themeConfig.icons || "#000000",
                            //             primaryButtonText: "#ffffff",
                            //             primaryButtonBg: themeConfig.buttons || "#000000",
                            //             primaryText: themeConfig.text || "#000000",
                            //             secondaryText: themeConfig.icons || "#000000",
                            //         }
                            //     })
                              
                            }
                            header={{
                              title: signinConfig.modalTitle || "",
                              titleIcon: convertB2ToS3Url(signinConfig.modalTitleIcon) || ""
                          }}
                        />
                        {/* <p 
                            className="m-0 text-base flex items-center px-6 gap-2 cursor-pointer font-medium pb-6 w-fit" 
                            style={{ color: currentTheme.colors.primaryText }}
                            onClick={() => router.back()}
                        >
                            <FaArrowLeft /> Back
                        </p> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;

export const getServerSideProps = withHeaderProps(async (context) => {
    // Your page-specific data fetching
    // const content = await fetchContent();
    
    // Example: Conditional redirect
    // if (!content) {
    //   return { redirect: { destination: '/', permanent: false } };
    // }
  
    return { props: { asdasd:"asdasd" } };
  });